import React, { Component, type ReactNode } from "react";

export interface IRaangeTooltipProps {
  tooltip: (element: HTMLElement) => ReactNode;
  tag?: string;
}

interface IRaangeTooltipState {
  ref: HTMLElement | null;
}

/**
 * @deprecated use Tooltip
 */
export class RaangeTooltip extends Component<
  IRaangeTooltipProps,
  IRaangeTooltipState
> {
  public state = {
    ref: null,
  };

  private setRef = (ref: HTMLElement | null): void => {
    if (!this.state.ref) {
      this.setState({
        ref,
      });
    }
  };

  public render(): ReactNode {
    const { children, tooltip, tag = "div" } = this.props;
    const { ref } = this.state;
    return React.createElement(tag, {
      ref: this.setRef,
      children: (
        <>
          {children}

          {ref !== null && tooltip(ref!)}
        </>
      ),
    });
  }
}

/**
 * @deprecated use Tooltip
 */
export default RaangeTooltip;
